import { apiClient } from '../http/client'
type JsonRecord = Record<string, unknown>

export const authApi = {
  exchangeTokenRoot: async (rootToken: string, signal?: AbortSignal, username?: string) => {
    const response = await apiClient.post('/auth/exchange', { root_token: rootToken, username }, { signal })
    return response.data as JsonRecord
  },
  exchangeTokenMock: async (mockUserId: string) => {
    const response = await apiClient.post('/auth/exchange', {
      mock: true,
      mock_user_id: mockUserId,
    })
    return response.data as JsonRecord
  },

  exchangeTokenHost: async (hostToken: string) => {
    const response = await apiClient.post('/auth/exchange', {
      mock: false,
      host_token: hostToken,
    })
    return response.data as JsonRecord
  },

  exchangeTokenWechat: async (wechatCode: string) => {
    const response = await apiClient.post('/auth/exchange', {
      mock: false,
      wechat_code: wechatCode,
    })
    return response.data as JsonRecord
  },

  getSession: async () => {
    const response = await apiClient.get('/auth/session')
    return response.data as JsonRecord
  },

  logout: async () => {
    const response = await apiClient.post('/auth/logout')
    return response.data as JsonRecord
  },
}
